import { getCurrentDate } from '../store';
import { createDateRange } from 'owa-datetime-utils';
import { getDateRangeISOString } from 'hybridspace-common/lib/utils/getDateRangeISOString';
import { getCurrentDateRange } from 'places-user-session-stores';
import type { DateRange } from 'owa-datetime-utils';

// Check if date range is for current date range (today or current week)
// This is specifically for collaborators to support the optimization where
// PlacesHomeRouteLayoutLoader uses week range instead of today range
// to avoid duplicate requests with WorkplanLoader
export function isCurrentDateRangeForCollaborators(dateRange: DateRange): boolean {
    const key = getDateRangeISOString(dateRange);
    const todayDateRangeKey = getDateRangeISOString(createDateRange(getCurrentDate(), 1));
    const weekDateRangeKey = getDateRangeISOString(getCurrentDateRange());
    return key === todayDateRangeKey || key === weekDateRangeKey;
}
